<template>
  <div>
    <div class="steps">
      <div class="tabs">
        <h3 class="tab tab-0">Dados pessoais</h3>
        <h3 class="tab tab-1">Propriedade(s)</h3>
        <h3 class="tab tab-2">Documentos</h3>
      </div>
      <div class="content">
        <div class="container content-0">
          <p class="text-description">
            O primeiro passo é a coleta de algumas informações básicas sobre você! Após preencher as informações obrigatórias
            <span
              class="text text-red"
            >(*)</span>, clique em
            <span class="text-next" @click="changeStep($event, +1)">Próximo</span>.
          </p>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group required">
                <label for="cpf_cnpj">CPF</label>
                <input
                  type="tel"
                  class="form-control loading"
                  v-mask="['###.###.###-##']"
                  name="cpf_cnpj"
                  id="cpf_cnpj"
                  v-model="cpfCnpj"
                  @blur="onCpfCnpjBlur"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="name">Nome completo</label>
                <input
                  type="text"
                  class="form-control"
                  name="name"
                  id="name"
                  v-model="produtor.nome"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="municipio">Município</label>
                <input
                  type="text"
                  class="form-control"
                  name="municipio_responsavel"
                  id="municipio-brasil"
                  v-model="produtor.municipio"
                />

                <input
                  type="hidden"
                  id="cod-municipio"
                  v-model="produtor.cod_municipio"
                  name="cod_municipio_responsavel"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="uf_responsavel">UF</label>
                <input
                  type="text"
                  class="form-control"
                  name="uf_responsavel"
                  id="uf_responsavel"
                  v-model="produtor.uf"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="celular">Celular</label>
                <input
                  type="tel"
                  class="form-control"
                  name="celular"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  id="celular"
                  v-model="produtor.celular"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label for="email">E-mail</label>
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  id="email"
                  @blur="onEmailBlur"
                  v-model="produtor.email"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="container content-1">
          <declaracao-propriedade-form
            :propriedades="produtor.propriedades"
            @nextStep="changeStep($event, +1)"
          ></declaracao-propriedade-form>
        </div>
        <div class="container content-2">
          <div class="row">
            <div class="col-md-7">
              <h3 class="m-0">Nota fiscal</h3>
              <small>
                Você pode enviar mais de uma, clicando em
                <span class="text text-primary text-bold">+</span>
              </small>
              <multiple-file-upload-component name="nota_fiscal"></multiple-file-upload-component>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group required">
                <h3 for="name" class="m-0">Documento de identificação (frente)</h3>
                <small>Ex.: RG ou CNH</small>
                <input
                  type="file"
                  class="form-control"
                  name="documento_identificacao_frente"
                  accept="application/pdf, image/*"
                />
              </div>

              <div class="form-group required">
                <h3 for="name" class="m-0">Documento de identificação (verso)</h3>
                <small>Ex.: RG ou CNH</small>
                <input
                  type="file"
                  class="form-control"
                  name="documento_identificacao_verso"
                  accept="application/pdf, image/*"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <h3 for="name" class="m-0">Comprovante de endereço (opcional)</h3>
                <input
                  type="file"
                  class="form-control"
                  name="comprovante_endereco"
                  accept="application/pdf, image/*"
                />
              </div>

              <br>
              <br>
              <br>
              <br>
              <br>
              <div class="form-check required">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="informacoes_veridicas"
                  value="1"
                  id="informacoesVeridicasCheck"
                />
                <label
                  class="form-check-label"
                  for="informacoesVeridicasCheck"
                >Declaro que as informações aqui prestadas são verídicas</label>
              </div>
            </div>
            <div class="col-md-12" style="align-items: center;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;">
              <div class="h-captcha" data-sitekey="1c13d2e6-c37a-4f6e-8731-57fab2e94178"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions">
        <a
          href="#"
          @click="changeStep($event, -1)"
          :class="{ 'steps-control': true, disabled: !allowPrev }"
        >Anterior</a>
        <a
          href="#"
          @click="changeStep($event, +1)"
          :class="{ 'steps-control': true, disabled: !produtorFound }"
        >{{ nextText }}</a>
      </div>
    </div>

    <div class="page-overlay" v-if="loading">
      <div class="spinner"></div>
    </div>
    <modal-component
      :title="feedback.cod == 0 ? 'Sucesso' : 'Erro'"
      :error="feedback.cod !== 0"
      :value="showFeedbackModal"
      :preventClose="feedback.cod == 0"
      @input="onCloseFeedbackModal"
    >
      <div class="modal-content">
        <p>{{ feedback.txt }}</p>
        <a href="/vacinacao/declaracao" class="btn-primary" v-if="feedback.cod == 0" target="_self">
          <span>Fechar</span>
        </a>
      </div>
    </modal-component>
  </div>
</template>

<script>
export default {
  data: () => ({
    activeTab: 0,
    nextText: "Próximo",
    showFeedbackModal: false,
    loading: false,
    feedback: {},
    cpfCnpj: "",
    produtorFound: false,
    produtor: {
      nome: "",
      municipio: "",
      cod_municipio: "",
      uf: "",
      celular: "",
      email: "",
      codAdagri: "",
      propriedades: []
    }
  }),
  computed: {
    allowPrev() {
      return this.activeTab > 0;
    }
  },
  methods: {
    changeActive() {
      document.querySelectorAll(`.tabs .tab`).forEach(node => {
        node.classList.remove("active");
      });
      document.querySelectorAll(`.content .container`).forEach(node => {
        node.classList.remove("active");
      });
      document
        .querySelector(`.tabs .tab.tab-${this.activeTab}`)
        .classList.add("active");
      document
        .querySelector(`.content .container.content-${this.activeTab}`)
        .classList.add("active");

      const stepsDiv = this.$el.querySelector(".steps");
      stepsDiv.scrollIntoView();
    },
    changeStep(ev, op) {
      ev && ev.preventDefault();
      ev && ev.stopPropagation();
      const tabsCount = this.$el.querySelectorAll(".tabs .tab").length;
      if (op < 0 && this.activeTab == 0) return;
      else if (op < 0) {
        this.activeTab += op;
        this.changeActive();
        this.nextText = "Próximo";
        return;
      } else if (op > 0 && !this.produtorFound) return;

      let hasError = false;
      let focusSeted = false;
      this.$el
        .querySelector(".container.active")
        .querySelectorAll(".form-group.required")
        .forEach(node => {
          const formControl = node.querySelector(".form-control");
          if (formControl && !formControl.value) {
            node.classList.add("error");
            hasError = true;

            if (!focusSeted) {
              formControl.focus();
              focusSeted = true;
            }
          } else {
            node.classList.remove("error");
          }
        });

      // Check if required checkbox are checked
      this.$el
        .querySelector(".container.active")
        .querySelectorAll(".form-check.required")
        .forEach(node => {
          const checkInput = node.querySelector(".form-check-input");
          if (!checkInput.checked) {
            node.classList.add("error");
            hasError = true;

            if (!focusSeted) {
              checkInput.focus();
              focusSeted = true;
            }
          } else {
            node.classList.remove("error");
          }
        });

      if (!hasError && op > 0 && this.activeTab == tabsCount - 1) {
        // Salvando
        this.onSave();
      } else if (!hasError) {
        this.activeTab += op;
        this.changeActive();
        if (this.activeTab === tabsCount - 1) {
          this.nextText = "Salvar";
        } else {
          this.nextText = "Próximo";
        }
      }
    },
    onSave() {
      const form = document.getElementById("pre-cadastro-produtor-form");
      const formData = new FormData(form);
      this.loading = true;

      if(this.validarCapctha()){
        axios
          .post("/vacinacao/declaracao/salvar", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => response.data)
          .then(response => {
            if (response.msg) {
              this.feedback = response.msg;
              this.showFeedbackModal = true;
            } else {
              throw "Resposta do servidor no formato inválido";
            }
          })
          .catch(error => {
            console.log(error);
            this.feedback = {
              cod: 1,
              txt:
                "Não foi possível se conectar com o servidor. Tente novamente mais tarde."
            };
            this.showFeedbackModal = true;
          })
          .then(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    onEmailBlur() {
      if (
        this.produtor.email !== "" &&
        !window.emailValidation(this.produtor.email)
      ) {
        this.produtor.email = "";
        alert("E-mail inváliddo");
      }
    },
    onCpfCnpjBlur() {
      const cpfCnpj = this.cpfCnpj.replace(/\D/g, "");
      let consult = "";

      if (cpfCnpj.length === 11) {
        consult = "cpf";
        this.isCpf = true;
        if (!window.cpfValidation(cpfCnpj)) {
          alert("CPF inváliddo");
          this.cpfCnpj = "";
          return;
        }
      } else {
        if (cpfCnpj != "") {
          alert("CPF/CNPJ inválido");
        }
        this.cpfCnpj = "";
        return;
      }
      this.loading = true;

      const scope = this;
      this.produtorFound = false;
      $.ajax({
        url: "vacinacao/declaracao/get-produtor",
        data: {
          cpf: cpfCnpj
        },
        dataType: "json",
        type: "GET",
        success: json => {
          scope.loading = false;
          if (json.msg && json.msg.cod === 1) {
            alert(
              "Produtor não encontrado. Caso isso seja um erro, entre em contato com nossa equipe."
            );
            return; // Error
          }

          this.produtorFound = true;
          scope.produtor = {
            nome: json.nomeprodutor,
            municipio: json.nomemunicipio,
            cod_municipio: json.codmunicipio,
            uf: json.codestado,
            celular: json.celular,
            email: json.email,
            codAdagri: "",
            codAdagri: json.pessoa_id,
            propriedades: json.propriedades
          };
        },
        error: () => {
          scope.loading = false;
          alert("Erro ao tentar carregar os dados");
        }
      });
    },
    onCloseFeedbackModal(ev) {
      this.showFeedbackModal = false;
    },

    validarCapctha() {
      //VERIFICA SE O HCATPCHA FOI SELECIONADO
      if (hcaptcha.getResponse() != "") return true;

      //IMPEDE O ENVIO DO FORMULÁRIO
      alert('Selecione a caixa de "Sou humano"');
      return false;
    },
  },
  mounted() {
    this.changeActive();

    // Ativar quando for necessário desativar o formulário
    // this.$el.querySelectorAll("input.form-control").forEach(node => node.setAttribute("disabled", "disabled"))
  }
};
</script>
<style lang="scss" scoped>
/deep/ .sida-modal {
  max-width: 500px;
  .modal-content {
    height: auto;
  }
}
</style>
